import Api from '../../../services';

export const getHostBookings = (params) => {
  return (dispatch) => {
    return Api.hostApi.bookings.getBookings(params).then((response) => {
      dispatch({
        type: 'GET_HOST_BOOKINGS',
        data: response,
      });
      return response;
    });
  };
};

export const getHostBookingDetails = (bookingId) => {
  return (dispatch) => {
    return Api.hostApi.bookings.getBookingDetails(bookingId).then((response) => {
      dispatch({
        type: 'GET_HOST_BOOKING_DETAILS',
        data: response,
      });
      return response;
    });
  };
};

export const rejectHostBooking = (bookingId, data) => {
  return (dispatch) => {
    return Api.hostApi.bookings.rejectBooking(bookingId, data).then((response) => {
      dispatch({
        type: 'REJECT_HOST_BOOKING',
        data: response,
      });
      return response;
    });
  };
};

export const approveHostBooking = (bookingId, data) => {
  return (dispatch) => {
    return Api.hostApi.bookings.approveBooking(bookingId, data).then((response) => {
      dispatch({
        type: 'APPROVE_HOST_BOOKING',
        data: response,
      });
      return response;
    });
  };
};

export const reviewBooking = (reviewId, data) => {
  return (dispatch) => {
    return Api.hostApi.bookings.reviewBooking(reviewId, data).then((response) => {
      dispatch({
        type: 'HOST_BOOKING_REVIEW',
        data: response,
      });
      return response;
    });
  };
};
